import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18BlocksG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "m4.867 4.4-.101.006a.81.81 0 0 0-.709.803L4.056 6.67l-.847.001a.81.81 0 0 0-.809.809v5.539a.8.8 0 0 0 .8.8h12.181a.81.81 0 0 0 .809-.81V7.471l-.006-.1a.8.8 0 0 0-.794-.7l-.858-.001.001-1.461a.81.81 0 0 0-.809-.809h-2.755l-.1.006a.8.8 0 0 0-.7.794l-.001 1.47H8.421l.001-1.461a.81.81 0 0 0-.809-.809zm8.465 1.199.001 1.672.008.097a.6.6 0 0 0 .592.503l1.056-.001v4.748H3.599V7.87l1.058.001.097-.008a.6.6 0 0 0 .503-.592l-.001-1.672h1.965l.001 1.672a.6.6 0 0 0 .6.6h2.947l.097-.008a.6.6 0 0 0 .503-.592l-.001-1.672z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18BlocksG$1 = Svg18BlocksG;

export { Svg18BlocksG$1 as default };
